import { render } from "./CreateGallery.vue?vue&type=template&id=096bb6ff"
import script from "./CreateGallery.vue?vue&type=script&lang=js"
export * from "./CreateGallery.vue?vue&type=script&lang=js"

import exportComponent from "E:\\laragon\\www\\RDRS_Union_Federation\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__